module.exports = __webpack_public_path__ + "static/media/dlc_02.d354456b.png";